import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0945 0.169308C12.9866 0.0610088 12.8417 0.000250208 12.6908 7.7105e-07C12.5398 -0.000248666 12.3947 0.0600308 12.2865 0.167973L0.448395 11.9738C0.346396 12.0755 0.284515 12.2122 0.274568 12.3578L0.00140665 16.3653C-0.00412448 16.4465 0.00669428 16.528 0.0331901 16.6047C0.0596859 16.6814 0.101292 16.7518 0.155421 16.8113C0.209549 16.8708 0.275043 16.9183 0.347828 16.9508C0.420613 16.9832 0.499132 17 0.578503 17C0.590749 17 0.603032 16.9996 0.615351 16.9988L4.62024 16.7371C4.75791 16.7281 4.88791 16.6689 4.98677 16.5702L16.8249 4.76453C16.8802 4.70935 16.9242 4.64338 16.9542 4.57051C16.9843 4.49763 16.9999 4.41933 17 4.34019C17.0001 4.26106 16.9848 4.1827 16.955 4.10973C16.9251 4.03675 16.8814 3.97064 16.8262 3.91528L13.0945 0.169308ZM4.3333 15.5668L1.20174 15.7714L1.41339 12.6666L10.2714 3.83283L13.1759 6.74827L4.3333 15.5668ZM14.0058 5.92056L11.1014 3.00516L12.6885 1.42232L15.593 4.33775L14.0058 5.92056Z",
		fill: "#C4C4C4"
	})
});
export default SvgPencil;
